import { InputLabel, InputLabelProps, styled } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';
export interface LabelProps extends Omit<InputLabelProps, 'size'> {
  text: ReactNode;
  useInfoIcon?: ReactElement;
  subTitle?: string;
}

export function Label({
  text,
  sx,
  disabled,
  required,
  id,
  subTitle = '',
  useInfoIcon
}: LabelProps) {
  return (
    <StyledLabel sx={sx} disabled={disabled} required={required} htmlFor={id}>
      {text}
      {useInfoIcon}
      {subTitle && <div>{subTitle}</div>}
    </StyledLabel>
  );
}

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  fontSize: theme.typography.labelXSmall.fontSize,
  lineHeight: theme.typography.labelSmall.lineHeight,
  color: theme.brandPalette.foreground.neutral,
  fontWeight: 400,
  letterSpacing: theme.typography.subheading2XSmall.letterSpacing,

  '& svg': {
    order: 2,
    color: theme.brandPalette.foreground.disabled
  },

  div: {
    color: theme.brandPalette.foreground.disabled,
    order: 1,
    fontWeight: 400
  },

  '&.Mui-required': {
    span: {
      color: theme.brandPalette.data.secondaryFaded
    }
  },

  '&.Mui-disabled': {
    color: theme.brandPalette.foreground.disabled,
    span: {
      color: theme.brandPalette.foreground.disabled
    }
  }
}));
